/* global YT, window */ 
export default {
	init() {

	var tag = document.createElement('script');


/* YOUTUBE API */

	tag.src = "https://www.youtube.com/iframe_api";
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

	var player;		
	window.onYouTubeIframeAPIReady = function() {
		player = new YT.Player('player', {
		height: '100%',
		width: '100%',
		videoId: '4C4_VkUxg3o',
		playerVars: {
			rel: 0
		},
		events: {
		'onReady': onPlayerReady,
				'onStateChange': onPlayerStateChange
		}
			});
		}

	function onPlayerReady() {

	}

	function onPlayerStateChange() {

	}

/* MENU */
	var navIcon = $('.mm_nav-icon'),
		menuChecked = 'mm_checked',
		openMenu = $('.mm_open-menu'),
		closeMenu = $('.mm_close-menu'),
		mmNav = $('nav.mm_navigation');

	navIcon.on('click', function () {
		navIcon.toggleClass(menuChecked);

		if (navIcon.hasClass(menuChecked)) {
			mmNav.fadeIn(300).addClass(menuChecked);
			openMenu.fadeOut(250);
			closeMenu.fadeIn(300);
		} else {
			mmNav.fadeOut(300).removeClass(menuChecked);
			closeMenu.fadeOut(250);
			openMenu.fadeIn(300);
		}
	});

	$(document).on('click', function (event) {
		if (navIcon.hasClass(menuChecked) && !$(event.target).closest(navIcon).length) {
			$('nav.mm_navigation').fadeOut(300);
			navIcon.removeClass(menuChecked);
		}
	});

			
/* WAYPOINT */

	$('.mm-article-section').waypoint(function () {
		$('.mm-photo-animated').addClass('mm_bind');
		this.destroy();
	}, {
		offset: '75%'
	});

//REMEMBER

	var rememberSection = $('.single-section-container-4');

	rememberSection.waypoint(function () {
		player.playVideo();
	}, {
		offset: '40%'
	});

	rememberSection.waypoint(function () {
		player.stopVideo();
	}, {
		offset: '41%'
	});

	rememberSection.waypoint(function () {
		player.playVideo();
	}, {
		offset: '-40%'
	});

//FRONT PAGE
	$('.wrapper-1').waypoint(function () {
		$('.wrapper-1').addClass('see-team');
		this.destroy();
	}, {
		offset: '40%'
	});

	$('.wrapper-2').waypoint(function () {
		$('.wrapper-2').addClass('see-team');
		this.destroy();
	}, {
		offset: '35%'
	});

	$('.wrapper-3').waypoint(function () {
		$('.wrapper-3').addClass('see-team');
		this.destroy();
	}, {
		offset: '40%'
	});

	$('.mm_team-desc').waypoint(function () {
		$('.mm_team-desc').addClass('see-team-desc');
		this.destroy();
	}, {
		offset: '80%'
	});


	$('.single-section-container-3').waypoint(function () {
		$('.mobile-hand-center').addClass('mm_animatedBackground');
		this.destroy();
	}, {
		offset: '40%'
	});
	
	$('.potfolio-mobile-content').waypoint(function () {
		$('.portfolio-mobile-screenshot').addClass('mm-scrolled-down');
		this.destroy();
	}, {
		offset: '40%'
	});
	
/* OWL CAROUSEL */

	$('.owl-carousel-3-items').on('initialized.owl.carousel resized.owl.carousel', function(){
		var i = 0,
			$items = $(this).find('.owl-item'),
			$item, w;

		for (i = 0; i < $items.length; ++i) {
			$item = $items.eq(i);
			w = $item.width();
			$item.css({width: (Math.ceil(w))+'px'});
		}
	}).owlCarousel({
		loop:true,
		margin:0,
		nav:false,
		responsive:{
			0:{
				items:1
			},
			600:{
				items:2
			},
			1000:{
				items:3
			}
		}
	});

	$('.owl-carousel-4-items').owlCarousel({
		loop:true,
		margin:0,
		nav:false,
		responsive:{
			0:{
				items:1
			},
			600:{
				items:2
			},
			1000:{
				items:4
			}
		}
	});

	$('.owl-carousel-5-items').owlCarousel({
		loop:true,
		margin:0,
		nav:false,
		responsive:{
			0:{
				items:1
			},
			600:{
				items:2
			},
			1000:{
				items:4
			}
		}
	});

/***** VERTICAL SLIDER *****/


$(".vertical-carousel").owlCarousel({
  loop: true,
  autoplay: true,
  items: 1,
  nav: false,
  mouseDrag: false,
  touchDrag: false,
  autoplayHoverPause: false,
  animateOut: 'slideOutUp',
  animateIn: 'slideInUp'
});

$(".mobile-clients-carousel").owlCarousel({
  loop: true,
  autoplay: true,
  items: 1,
  nav: false,
  mouseDrag: true,
  touchDrag: true,
  autoplayHoverPause: false
});




$('.client-logo-container').not('.mobile-clients-carousel .client-logo-container').each(function(){
   
    var random = Math.floor(Math.random()*50);
    
    $(this).css({
        paddingTop: random + '%',
        paddingBottom: (80-random) + '%'
    });
    
});

/***** WAYPOINTS *****/


	$('.onas-2 .onas-2-1').waypoint(function () {
		$('.onas-2-1 img.onas').addClass('mm_bind-nk');
		this.destroy();
	}, {
		offset: '50%'
	});
			
	$('.onas-2 .onas-2-2').waypoint(function () {
		$('.onas-2-2 img.onas').addClass('mm_bind-nk');
		this.destroy();
	}, {
		offset: '50%'
	});

	$('.onas-2 .onas-2-3').waypoint(function () {
		$('.onas-2-3 img.onas').addClass('mm_bind-nk');
		this.destroy();
	}, {
		offset: '50%'
	});

        var url = $('.mm-main-header h2').data('sprite');

        var tmp = $('<img>');
        tmp.attr('src', url);

        tmp.on('load', function(){
            $('.mm-main-header').addClass('animated-header');
        });

    
        $('.mm-animated-header').each(function(){
            
            var $this = $(this);
            
            var url = $('h2', $this).data('sprite');

            var tmp = $('<img>');
            tmp.attr('src', url);

            tmp.on('load', function(){
                $this.addClass('mm-animated-header--initiated');
                console.log('index: '+$this.index());
                if($this.index() === 0) {
                    $this.addClass('mm-animated-header--in');
                }
            });

        });

		$('.mm-main-header .mm-scroll-down').on('click', function(){
			console.log('click');
			$('html, body').delay(100).animate({
				scrollTop: $('.mm-main-header').next('section').offset().top
			}, 700 );
		});
    
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	}
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js